module.exports = __webpack_public_path__ + "media/images/pic/brodno/people/kasia-dffc1d18b9f3f2ccec61743f5a6b92ee.webp";